module["exports"] = [
  "Apt. ###",
  "Suite ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/secondary_address.js
 ** module id = 1019
 ** module chunks = 0
 **/